var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, SubCollection, Collection, File, } from '@1amageek/ballcap';
import { Base } from '.';
import { Utils } from '../../../common/helper';
export class Clinic extends Base {
    constructor() {
        super(...arguments);
        // カウンター
        this.clinicCounter = new Collection();
        // 求人情報
        this.jobOffers = new Collection();
        // チェックイン状況
        this.jobCheckIns = new Collection();
    }
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('clinics');
    }
    static fromRawValue(documentReference, corporateName, clinicName, facilityId, tel, email, prefectureId, locationAddress, firstNameOfRecruiter, lastNameOfRecruiter, latitude, longitude) {
        const item = new Clinic(documentReference);
        item.corporateName = corporateName;
        item.clinicName = clinicName;
        item.facilityId = facilityId;
        item.tel = tel;
        item.email = email;
        item.prefectureId = prefectureId;
        item.locationAddress = locationAddress;
        item.firstNameOfRecruiter = firstNameOfRecruiter;
        item.lastNameOfRecruiter = lastNameOfRecruiter;
        item.latitude = latitude;
        item.longitude = longitude;
        return item;
    }
    fullNamefRecruiter() {
        if (Utils.isNull(this.lastNameOfRecruiter) || Utils.isNull(this.firstNameOfRecruiter)) {
            return '';
        }
        return `${this.lastNameOfRecruiter} ${this.firstNameOfRecruiter}`;
    }
    facilityDivName(master) {
        var _a, _b, _c, _d;
        if (Utils.isNull(this.facilityId) || Utils.isNull((_a = master) === null || _a === void 0 ? void 0 : _a.facilityList))
            return '';
        return (_d = (_c = (_b = master) === null || _b === void 0 ? void 0 : _b.facilityList) === null || _c === void 0 ? void 0 : _c.find((d) => d.id === this.facilityId)) === null || _d === void 0 ? void 0 : _d.text;
    }
    prefectureName(master) {
        var _a, _b, _c, _d;
        if (Utils.isNull(this.prefectureId) || Utils.isNull((_a = master) === null || _a === void 0 ? void 0 : _a.prefectureList))
            return '';
        return (_d = (_c = (_b = master) === null || _b === void 0 ? void 0 : _b.prefectureList) === null || _c === void 0 ? void 0 : _c.find((d) => d.id === this.prefectureId)) === null || _d === void 0 ? void 0 : _d.text;
    }
    setImageFromCloudStorage(data) {
        const image = new File();
        console.log('snapshot.downloadURL', data);
        image.path = data.path;
        image.url = data.url;
        image.metadata = {
            name: data.metadata.name,
        };
        this.image = image;
    }
    jobOfferThumnailsPath(jobOfferId) {
        // job/v1/clinics/:uid/jobOffers/:jobOfferId/thumbnails
        return this.jobOffers.collectionReference.doc(jobOfferId).path + '/thumbnails';
    }
    jobOfferDocumentsPath(jobOfferId) {
        // job/v1/clinics/:uid/jobOffers/:jobOfferId/documents
        return this.jobOffers.collectionReference.doc(jobOfferId).path + '/documents';
    }
}
Clinic.imageFolderName = 'image';
Clinic.imageName = 'clinic_profile';
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "corporateName", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "clinicName", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "facilityId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "tel", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "email", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "prefectureId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "locationAddress", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "latitude", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], Clinic.prototype, "longitude", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "firstNameOfRecruiter", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "lastNameOfRecruiter", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Clinic.prototype, "position", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Clinic.prototype, "isArchive", void 0);
__decorate([
    Field,
    __metadata("design:type", File
    // カウンター
    )
], Clinic.prototype, "image", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "clinicCounter", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "jobOffers", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], Clinic.prototype, "jobCheckIns", void 0);
